export const environment = {
  production: false,
  env: 'app',
  flag: {
    DEV: {
      PY: {
        production: false,
        adminModule: true,
        alertServiceBaseUrl:
          'https://api-portfolio-management-alert-dev.npe.intl.br-use4.gcp.efx:443',
        billingServiceBaseUrl:
          'https://api-portfolio-management-billing-dev.npe.intl.br-use4.gcp.efx:443',
        bulkLoadServiceBaseUrl:
          'https://api-portfolio-management-bulk-dev.npe.intl.br-use4.gcp.efx:443',
        configurationServiceBaseUrl:
          'https://api-portfolio-management-config-dev.npe.intl.br-use4.gcp.efx:443',
        dataIngestionServiceBaseUrl:
          'https://api-portfolio-management-ingestion-dev.npe.intl.br-use4.gcp.efx:443',
        walletServiceBaseUrl:
          'https://api-portfolio-management-wallet-dev.npe.intl.br-use4.gcp.efx:443',
        backendUri: 'https://api-portfolio-management-dev.npe.intl.br-use4.gcp.efx/',
        redirectInteractiveReport: 'https://interactivereportsdev.npe.intl.ar.gcp.efx/',
        appDomain: 'https://portfolio-management-dev.npe.intl.br-use4.gcp.efx',
        commerce: 'https://commerce.pa-us-east1.gcp.efx/ui-app-center/products',
        oidc: {
          client_id: '0oar9bvz3oBjXB1zX4x7',
          issuer: 'https://login-qa.equifax.com/as',
          redirect_uri: 'https://portfolio-management-dev.npe.intl.br-use4.gcp.efx/sso/callback',
          login_url: 'https://ciam.qa.sec.us-use1.gcp.efx/auth/login',
          post_logout_redirect_uri: 'https://ciam.qa.sec.us-use1.gcp.efx/auth/login',
        },
        okta: {
          client_id: '0oar9bvz3oBjXB1zX4x7',
          issuer: 'https://authsvc-alpha.equifax.com/oauth2/aus14yiycrjuMAa3b4x7',
          redirect_uri: 'https://portfolio-management-dev.npe.intl.br-use4.gcp.efx/sso/callback',
          login_url: 'https://commerce.pa-us-east1.gcp.efx/auth/login?store=intl_b2b_br',
          logout_url: 'https://commerce.pa-us-east1.gcp.efx/auth/logout',
          post_logout_redirect_uri: 'https://commerce.pa-us-east1.gcp.efx/auth/logout',
        },
        featureToggles: {
          enablePlans: true,
          showPersonTypeToggle: true,
        },
      },
      BR: {
        production: false,
        adminModule: true,
        alertServiceBaseUrl:
          'https://api-portfolio-management-alert-dev.npe.intl.br-use4.gcp.efx:443',
        billingServiceBaseUrl:
          'https://api-portfolio-management-billing-dev.npe.intl.br-use4.gcp.efx:443',
        bulkLoadServiceBaseUrl:
          'https://api-portfolio-management-bulk-dev.npe.intl.br-use4.gcp.efx:443',
        configurationServiceBaseUrl:
          'https://api-portfolio-management-config-dev.npe.intl.br-use4.gcp.efx:443',
        dataIngestionServiceBaseUrl:
          'https://api-portfolio-management-ingestion-dev.npe.intl.br-use4.gcp.efx:443',
        walletServiceBaseUrl:
          'https://api-portfolio-management-wallet-dev.npe.intl.br-use4.gcp.efx:443',
        backendUri: 'https://api-portfolio-management-dev.npe.intl.br-use4.gcp.efx/',
        redirectInteractiveReport: 'https://interactivereportsdev.npe.intl.ar.gcp.efx/',
        appDomain: 'https://portfolio-management-dev.npe.intl.br-use4.gcp.efx',
        commerce: 'https://commerce.pa-us-east1.gcp.efx/ui-app-center/products',
        oidc: {
          client_id: '0oar9bvz3oBjXB1zX4x7',
          issuer: 'https://login-qa.equifax.com/as',
          redirect_uri: 'https://portfolio-management-dev.npe.intl.br-use4.gcp.efx/sso/callback',
          login_url: 'https://ciam.qa.sec.us-use1.gcp.efx/auth/login',
          post_logout_redirect_uri: 'https://ciam.qa.sec.us-use1.gcp.efx/auth/login',
        },
        okta: {
          client_id: '0oar9bvz3oBjXB1zX4x7',
          issuer: 'https://authsvc-alpha.equifax.com/oauth2/aus14yiycrjuMAa3b4x7',
          redirect_uri: 'https://portfolio-management-dev.npe.intl.br-use4.gcp.efx/sso/callback',
          login_url: 'https://commerce.pa-us-east1.gcp.efx/auth/login?store=intl_b2b_br',
          logout_url: 'https://commerce.pa-us-east1.gcp.efx/auth/logout',
          post_logout_redirect_uri: 'https://commerce.pa-us-east1.gcp.efx/auth/logout',
        },
        featureToggles: {
          enablePlans: true,
          showPersonTypeToggle: true,
        },
      },
    },
    PREHML: {
      PY: {
        production: false,
        alertServiceBaseUrl:
          'https://api-portfolio-management-alert-pre.npe.intl.br-use4.gcp.efx:443',
        billingServiceBaseUrl:
          'https://api-portfolio-management-billing-pre.npe.intl.br-use4.gcp.efx:443',
        bulkLoadServiceBaseUrl:
          'https://api-portfolio-management-bulk-pre.npe.intl.br-use4.gcp.efx:443',
        configurationServiceBaseUrl:
          'https://api-portfolio-management-config-pre.npe.intl.br-use4.gcp.efx:443',
        dataIngestionServiceBaseUrl:
          'https://api-portfolio-management-ingestion-pre.npe.intl.br-use4.gcp.efx:443',
        walletServiceBaseUrl:
          'https://api-portfolio-management-wallet-pre.npe.intl.br-use4.gcp.efx:443',
        backendUri: 'https://api-portfolio-management-pre-qa.npe.intl.br-use4.gcp.efx/',
        redirectInteractiveReport: 'https://interactivereportsdev.npe.intl.ar.gcp.efx/',
        appDomain: 'https://portfolio-management-pre-qa.npe.intl.br-use4.gcp.efx',
        commerce: 'https://commerce.pa-us-east1.gcp.efx/ui-app-center/products',
        oidc: {
          client_id: '0oar9bvz3oBjXB1zX4x7',
          issuer: 'https://login-qa.equifax.com/as',
          redirect_uri: 'https://portfolio-management-pre-qa.npe.intl.br-use4.gcp.efx/sso/callback',
          login_url: 'https://ciam.qa.sec.us-use1.gcp.efx/auth/login',
          post_logout_redirect_uri: 'https://ciam.qa.sec.us-use1.gcp.efx/auth/login',
        },
        okta: {
          client_id: '0oar9bvz3oBjXB1zX4x7',
          issuer: 'https://authsvc-alpha.equifax.com/oauth2/aus14yiycrjuMAa3b4x7',
          redirect_uri: 'https://portfolio-management-pre-qa.npe.intl.br-use4.gcp.efx/sso/callback',
          login_url: 'https://commerce.pa-us-east1.gcp.efx/auth/login?store=intl_b2b_br',
          logout_url: 'https://commerce.pa-us-east1.gcp.efx/auth/logout',
          post_logout_redirect_uri: 'https://commerce.pa-us-east1.gcp.efx/auth/logout',
        },
        featureToggles: {
          enablePlans: true,
          showPersonTypeToggle: true,
        },
      },
      BR: {
        production: false,
        alertServiceBaseUrl:
          'https://api-portfolio-management-alert-pre.npe.intl.br-use4.gcp.efx:443',
        billingServiceBaseUrl:
          'https://api-portfolio-management-billing-pre.npe.intl.br-use4.gcp.efx:443',
        bulkLoadServiceBaseUrl:
          'https://api-portfolio-management-bulk-pre.npe.intl.br-use4.gcp.efx:443',
        configurationServiceBaseUrl:
          'https://api-portfolio-management-config-pre.npe.intl.br-use4.gcp.efx:443',
        dataIngestionServiceBaseUrl:
          'https://api-portfolio-management-ingestion-pre.npe.intl.br-use4.gcp.efx:443',
        walletServiceBaseUrl:
          'https://api-portfolio-management-wallet-pre.npe.intl.br-use4.gcp.efx:443',
        backendUri: 'https://api-portfolio-management-pre-qa.npe.intl.br-use4.gcp.efx/',
        redirectInteractiveReport: 'https://interactivereportsdev.npe.intl.ar.gcp.efx/',
        appDomain: 'https://portfolio-management-pre-qa.npe.intl.br-use4.gcp.efx',
        commerce: 'https://commerce.pa-us-east1.gcp.efx/ui-app-center/products',
        oidc: {
          client_id: '0oar9bvz3oBjXB1zX4x7',
          issuer: 'https://login-qa.equifax.com/as',
          redirect_uri: 'https://portfolio-management-pre-qa.npe.intl.br-use4.gcp.efx/sso/callback',
          login_url: 'https://ciam.qa.sec.us-use1.gcp.efx/auth/login',
          post_logout_redirect_uri: 'https://ciam.qa.sec.us-use1.gcp.efx/auth/login',
        },
        okta: {
          client_id: '0oar9bvz3oBjXB1zX4x7',
          issuer: 'https://authsvc-alpha.equifax.com/oauth2/aus14yiycrjuMAa3b4x7',
          redirect_uri: 'https://portfolio-management-pre-qa.npe.intl.br-use4.gcp.efx/sso/callback',
          login_url: 'https://commerce.pa-us-east1.gcp.efx/auth/login?store=intl_b2b_br',
          logout_url: 'https://commerce.pa-us-east1.gcp.efx/auth/logout',
          post_logout_redirect_uri: 'https://commerce.pa-us-east1.gcp.efx/auth/logout',
        },
        featureToggles: {
          enablePlans: true,
          showPersonTypeToggle: true,
        },
      },
    },
    HML: {
      PY: {
        production: false,
        alertServiceBaseUrl:
          'https://api-portfolio-management-alert-qa.npe.intl.br-use4.gcp.efx:443',
        billingServiceBaseUrl:
          'https://api-portfolio-management-billing-qa.npe.intl.br-use4.gcp.efx:443',
        bulkLoadServiceBaseUrl:
          'https://api-portfolio-management-bulk-qa.npe.intl.br-use4.gcp.efx:443',
        configurationServiceBaseUrl:
          'https://api-portfolio-management-config-qa.npe.intl.br-use4.gcp.efx:443',
        dataIngestionServiceBaseUrl:
          'https://api-portfolio-management-ingestion-qa.npe.intl.br-use4.gcp.efx:443',
        walletServiceBaseUrl:
          'https://api-portfolio-management-wallet-qa.npe.intl.br-use4.gcp.efx:443',
        backendUri: 'https://api-portfolio-management-qa.npe.intl.br-use4.gcp.efx/',
        redirectInteractiveReport: 'https://interactivereportsdev.npe.intl.ar.gcp.efx/',
        appDomain: 'https://portfolio-management-qa.npe.intl.br-use4.gcp.efx',
        commerce: 'https://commerce.pa-us-east1.gcp.efx/ui-app-center/products',
        oidc: {
          client_id: '0oar9bvz3oBjXB1zX4x7',
          issuer: 'https://login-qa.equifax.com/as',
          redirect_uri: 'https://portfolio-management-qa.npe.intl.br-use4.gcp.efx/sso/callback',
          login_url: 'https://ciam.qa.sec.us-use1.gcp.efx/auth/login',
          post_logout_redirect_uri: 'https://ciam.qa.sec.us-use1.gcp.efx/auth/login',
        },
        okta: {
          client_id: '0oar9bvz3oBjXB1zX4x7',
          issuer: 'https://authsvc-alpha.equifax.com/oauth2/aus14yiycrjuMAa3b4x7',
          redirect_uri: 'https://portfolio-management-qa.npe.intl.br-use4.gcp.efx/sso/callback',
          login_url: 'https://commerce.pa-us-east1.gcp.efx/auth/login?store=intl_b2b_br',
          logout_url: 'https://commerce.pa-us-east1.gcp.efx/auth/logout',
          post_logout_redirect_uri: 'https://commerce.pa-us-east1.gcp.efx/auth/logout',
        },
        featureToggles: {
          enablePlans: true,
          showPersonTypeToggle: true,
        },
      },
      BR: {
        production: false,
        alertServiceBaseUrl:
          'https://api-portfolio-management-alert-qa.npe.intl.br-use4.gcp.efx:443',
        billingServiceBaseUrl:
          'https://api-portfolio-management-billing-qa.npe.intl.br-use4.gcp.efx:443',
        bulkLoadServiceBaseUrl:
          'https://api-portfolio-management-bulk-qa.npe.intl.br-use4.gcp.efx:443',
        configurationServiceBaseUrl:
          'https://api-portfolio-management-config-qa.npe.intl.br-use4.gcp.efx:443',
        dataIngestionServiceBaseUrl:
          'https://api-portfolio-management-ingestion-qa.npe.intl.br-use4.gcp.efx:443',
        walletServiceBaseUrl:
          'https://api-portfolio-management-wallet-qa.npe.intl.br-use4.gcp.efx:443',
        backendUri: 'https://api-portfolio-management-qa.npe.intl.br-use4.gcp.efx/',
        redirectInteractiveReport: 'https://interactivereportsdev.npe.intl.ar.gcp.efx/',
        appDomain: 'https://portfolio-management-qa.npe.intl.br-use4.gcp.efx',
        commerce: 'https://commerce.pa-us-east1.gcp.efx/ui-app-center/products',
        oidc: {
          client_id: '0oar9bvz3oBjXB1zX4x7',
          issuer: 'https://login-qa.equifax.com/as',
          redirect_uri: 'https://portfolio-management-qa.npe.intl.br-use4.gcp.efx/sso/callback',
          login_url: 'https://ciam.qa.sec.us-use1.gcp.efx/auth/login',
          post_logout_redirect_uri: 'https://ciam.qa.sec.us-use1.gcp.efx/auth/login',
        },
        okta: {
          client_id: '0oar9bvz3oBjXB1zX4x7',
          issuer: 'https://authsvc-alpha.equifax.com/oauth2/aus14yiycrjuMAa3b4x7',
          redirect_uri: 'https://portfolio-management-qa.npe.intl.br-use4.gcp.efx/sso/callback',
          login_url: 'https://commerce.pa-us-east1.gcp.efx/auth/login?store=intl_b2b_br',
          logout_url: 'https://commerce.pa-us-east1.gcp.efx/auth/logout',
          post_logout_redirect_uri: 'https://commerce.pa-us-east1.gcp.efx/auth/logout',
        },
        featureToggles: {
          enablePlans: true,
          showPersonTypeToggle: true,
        },
      },
    },
    UAT: {
      PY: {
        production: true,
        alertServiceBaseUrl: 'https://uat.gerportfolio.equifax.com/backend/alert',
        billingServiceBaseUrl: 'https://uat.gerportfolio.equifax.com/backend/billing',
        bulkLoadServiceBaseUrl: 'https://uat.gerportfolio.equifax.com/backend/bulk-load',
        configurationServiceBaseUrl: 'https://uat.gerportfolio.equifax.com/backend/configuration',
        dataIngestionServiceBaseUrl: 'https://uat.gerportfolio.equifax.com/backend/data-ingestion',
        walletServiceBaseUrl: 'https://uat.gerportfolio.equifax.com/backend/wallet',
        backendUri: 'https://api-portfolio-management-uat.prd.intl.br-use4.gcp.efx/',
        redirectInteractiveReport: 'https://interactivereportsdev.npe.intl.ar.gcp.efx/',
        appDomain: 'https://uat.gerportfolio.equifax.com',
        commerce: 'https://business-dr.equifax.com/ui-app-center/products',
        oidc: {
          client_id: '0oarmz3f3t7RFkiW94x7',
          issuer: 'https://login-uat.equifax.com/as',
          redirect_uri: 'https://uat.gerportfolio.equifax.com/sso/callback',
          login_url: 'https://secure-uat.equifax.com/auth/login',
          post_logout_redirect_uri: 'https://secure-uat.equifax.com/auth/login',
        },
        okta: {
          client_id: '0oarmz3f3t7RFkiW94x7',
          issuer: 'https://authsvc-beta.equifax.com/oauth2/aus150lkbcOvGohjh4x7',
          redirect_uri: 'https://uat.gerportfolio.equifax.com/sso/callback',
          login_url: 'https://business-dr.equifax.com/auth/login?store=intl_b2b_br',
          logout_url: 'https://business-dr.equifax.com/auth/logout',
          post_logout_redirect_uri: 'https://business-dr.equifax.com/auth/logout',
        },
        featureToggles: {
          enablePlans: true,
          showPersonTypeToggle: true,
        },
      },
      BR: {
        production: true,
        alertServiceBaseUrl: 'https://uat.gerportfolio.equifax.com/backend/alert',
        billingServiceBaseUrl: 'https://uat.gerportfolio.equifax.com/backend/billing',
        bulkLoadServiceBaseUrl: 'https://uat.gerportfolio.equifax.com/backend/bulk-load',
        configurationServiceBaseUrl: 'https://uat.gerportfolio.equifax.com/backend/configuration',
        dataIngestionServiceBaseUrl: 'https://uat.gerportfolio.equifax.com/backend/data-ingestion',
        walletServiceBaseUrl: 'https://uat.gerportfolio.equifax.com/backend/wallet',
        backendUri: 'https://api-portfolio-management-uat.prd.intl.br-use4.gcp.efx/',
        redirectInteractiveReport: 'https://interactivereportsdev.npe.intl.ar.gcp.efx/',
        appDomain: 'https://uat.gerportfolio.equifax.com',
        commerce: 'https://business-dr.equifax.com/ui-app-center/products',
        oidc: {
          client_id: '0oarmz3f3t7RFkiW94x7',
          issuer: 'https://login-uat.equifax.com/as',
          redirect_uri: 'https://uat.gerportfolio.equifax.com/sso/callback',
          login_url: 'https://secure-uat.equifax.com/auth/login',
          post_logout_redirect_uri: 'https://secure-uat.equifax.com/auth/login',
        },
        okta: {
          client_id: '0oarmz3f3t7RFkiW94x7',
          issuer: 'https://authsvc-beta.equifax.com/oauth2/aus150lkbcOvGohjh4x7',
          redirect_uri: 'https://uat.gerportfolio.equifax.com/sso/callback',
          login_url: 'https://business-dr.equifax.com/auth/login?store=intl_b2b_br',
          logout_url: 'https://business-dr.equifax.com/auth/logout',
          post_logout_redirect_uri: 'https://business-dr.equifax.com/auth/logout',
        },
        featureToggles: {
          enablePlans: true,
          showPersonTypeToggle: true,
        },
      },
    },
    PROD: {
      PY: {
        production: true,
        alertServiceBaseUrl: 'https://gerportfolio.equifax.com/backend/alert',
        billingServiceBaseUrl: 'https://gerportfolio.equifax.com/backend/billing',
        bulkLoadServiceBaseUrl: 'https://gerportfolio.equifax.com/backend/bulk-load',
        configurationServiceBaseUrl: 'https://gerportfolio.equifax.com/backend/configuration',
        dataIngestionServiceBaseUrl: 'https://gerportfolio.equifax.com/backend/data-ingestion',
        walletServiceBaseUrl: 'https://gerportfolio.equifax.com/backend/wallet',
        backendUri: 'https://api-portfolio-management.prd.intl.br-use4.gcp.efx/',
        redirectInteractiveReport: 'https://interactivereportsdev.npe.intl.ar.gcp.efx/',
        appDomain: 'https://gerportfolio.equifax.com',
        commerce: 'https://business.equifax.com/ui-app-center/products',
        oidc: {
          client_id: '0oarz689nfE6HmXID4x7',
          issuer: 'https://login.equifax.com/as',
          redirect_uri: 'https://gerportfolio.equifax.com/sso/callback',
          login_url: 'https://secure.equifax.com/auth/login',
          post_logout_redirect_uri: 'https://secure.equifax.com/auth/login',
        },
        okta: {
          client_id: '0oarz689nfE6HmXID4x7',
          issuer: 'https://authsvc.equifax.com/oauth2/aus15rk5j1NuHxAJc4x7',
          redirect_uri: 'https://gerportfolio.equifax.com/sso/callback',
          login_url: 'https://business.equifax.com/auth/login?store=intl_b2b_br',
          logout_url: 'https://business.equifax.com/auth/logout',
          post_logout_redirect_uri: 'https://business.equifax.com/auth/logout',
        },
        featureToggles: {
          enablePlans: true,
          showPersonTypeToggle: false,
        },
      },
      BR: {
        production: true,
        alertServiceBaseUrl: 'https://gerportfolio.equifax.com/backend/alert',
        billingServiceBaseUrl: 'https://gerportfolio.equifax.com/backend/billing',
        bulkLoadServiceBaseUrl: 'https://gerportfolio.equifax.com/backend/bulk-load',
        configurationServiceBaseUrl: 'https://gerportfolio.equifax.com/backend/configuration',
        dataIngestionServiceBaseUrl: 'https://gerportfolio.equifax.com/backend/data-ingestion',
        walletServiceBaseUrl: 'https://gerportfolio.equifax.com/backend/wallet',
        backendUri: 'https://api-portfolio-management.prd.intl.br-use4.gcp.efx/',
        redirectInteractiveReport: 'https://interactivereportsdev.npe.intl.ar.gcp.efx/',
        appDomain: 'https://gerportfolio.equifax.com',
        commerce: 'https://business.equifax.com/ui-app-center/products',
        oidc: {
          client_id: '0oarz689nfE6HmXID4x7',
          issuer: 'https://login.equifax.com/as',
          redirect_uri: 'https://gerportfolio.equifax.com/sso/callback',
          login_url: 'https://secure.equifax.com/auth/login',
          post_logout_redirect_uri: 'https://secure.equifax.com/auth/login',
        },
        okta: {
          client_id: '0oarz689nfE6HmXID4x7',
          issuer: 'https://authsvc.equifax.com/oauth2/aus15rk5j1NuHxAJc4x7',
          redirect_uri: 'https://gerportfolio.equifax.com/sso/callback',
          login_url: 'https://business.equifax.com/auth/login?store=intl_b2b_br',
          logout_url: 'https://business.equifax.com/auth/logout',
          post_logout_redirect_uri: 'https://business.equifax.com/auth/logout',
        },
        featureToggles: {
          enablePlans: true,
          showPersonTypeToggle: false,
        },
      },
    },
  },
  country: {
    py: [
      '7c1b413e-70ad-423e-b32c-bb42e0659cb2', // localhost
      'b2285a49-adf1-4c32-bae5-7cfd0c319299', // DEV
      'eb1ddc61-397c-410c-8ef1-22e34888b210', // PREHML (PRE-QA)
      'e49da078-6e60-421c-8675-c34ff8f5e64f', // HML
      '579974d5-b478-4f04-a01c-a198dd521b32', // UAT
      '4855c44b-9e3f-4d5f-a1a3-857091d96e78', // PRD
    ],
    br: [
      'd8e71839-4169-40a2-97bf-47e14d355388', // localhost
      'f59abddc-fa43-4f23-8cc6-32337aeba94f', // DEV
      'c85d91f1-94d3-4f14-93fe-5acf17c5cbb1', // PREHML (PRE-QA)
      '89a30540-c428-470a-bf26-0320ba704cdd', // HML
      '5991bced-9cf9-4fb5-8326-c2d19a4f3e46', // UAT
      '7b1ca188-9e66-4bcd-848f-e9db89e6ea35', // PRD
    ],
  },
  emailsRegExp:
    /^((?=.{1,100}@)[A-Za-z0-9_-]+(\.[A-Za-z0-9_-]+)*@[^-][A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,4},?))+$/,
  newAlert: {
    AR: [
      {
        id: 0,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BCRA',
        name: 'BCRA',
        state: false,
        secureDispatch: false,
        emails: [],
      },
      {
        id: 1,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BCRA_NEGATIVO',
        name: 'BCRA Negativo',
        state: false,
        secureDispatch: false,
        emails: [],
      },
      {
        id: 2,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BCRA_POSITIVO',
        name: 'BCRA Positivo',
        state: false,
        secureDispatch: false,
        emails: [],
      },
      {
        id: 3,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BUREAU_NEGATIVO',
        name: 'BUREAU Negativo',
        state: false,
        secureDispatch: false,
        emails: [],
      },
      {
        id: 4,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BUREAU_POSITIVO',
        name: 'BUREAU Positivo',
        state: false,
        secureDispatch: false,
        emails: [],
      },
      {
        id: 5,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'CHEQUE_RECHAZADO',
        name: 'Cheques Rechazados',
        state: false,
        secureDispatch: false,
        emails: [],
      },
      {
        id: 6,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'CONSULTAS',
        name: 'Consultas',
        state: false,
        secureDispatch: false,
        emails: [],
      },
      {
        id: 7,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'RELACIONES',
        name: 'Relaciones',
        state: false,
        secureDispatch: false,
        emails: [],
      },
      {
        id: 8,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'QUIEBRAS',
        name: 'Observaciones',
        state: false,
        secureDispatch: false,
        emails: [],
      },
      {
        id: 9,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BCRA',
        name: 'BCRA',
        state: false,
        secureDispatch: true,
        emails: [],
      },
      {
        id: 10,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BCRA_NEGATIVO',
        name: 'BCRA Negativo',
        state: false,
        secureDispatch: true,
        emails: [],
      },
      {
        id: 11,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BCRA_POSITIVO',
        name: 'BCRA Positivo',
        state: false,
        secureDispatch: true,
        emails: [],
      },
      {
        id: 12,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BUREAU_NEGATIVO',
        name: 'BUREAU Negativo',
        state: false,
        secureDispatch: true,
        emails: [],
      },
      {
        id: 13,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BUREAU_POSITIVO',
        name: 'BUREAU Positivo',
        state: false,
        secureDispatch: true,
        emails: [],
      },
      {
        id: 14,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'CHEQUE_RECHAZADO',
        name: 'Cheques Rechazados',
        state: false,
        secureDispatch: true,
        emails: [],
      },
      {
        id: 15,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'CONSULTAS',
        name: 'Consultas',
        state: false,
        secureDispatch: true,
        emails: [],
      },
      {
        id: 16,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'RELACIONES',
        name: 'Relaciones',
        state: false,
        secureDispatch: true,
        emails: [],
      },
      {
        id: 17,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'QUIEBRAS',
        name: 'Observaciones',
        state: false,
        secureDispatch: true,
        emails: [],
      },
    ],
    CL: [
      {
        id: 1,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BIENES_RAICES',
        name: 'BIENES RAICES',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 2,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BOLCOM',
        name: 'BOLCOM',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 3,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'CONSULTAS',
        name: 'CONSULTAS',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 4,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'DEFUNCIONES',
        name: 'DEFUNCIONES',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 5,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'DICOM',
        name: 'DICOM',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 6,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'DIRECCIONES',
        name: 'DIRECCIONES',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 7,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'DIRECTORIO_EMPRESAS',
        name: 'DIRECTORIO EMPRESAS',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 8,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'DIRECTORIO_PERSONAS',
        name: 'DIRECTORIO PERSONAS',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 9,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'QUIEBRAS',
        name: 'QUIEBRAS',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 10,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'SOCIOS',
        name: 'SOCIOS',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      // {
      //     id: 11,
      //     alert_id: null,
      //     id_tracking_record: null,
      //     alert_type: "BOLETIN_LABORAL",
      //     name: "BOLETIN LABORAL",
      //     secureDispatch: false,
      //     state: false,
      //     emails: []
      // }
    ],
    CR: [
      {
        id: 1,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BIENES_RAICES',
        name: 'BIENES RAICES',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 2,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BOLCOM',
        name: 'BOLCOM',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 3,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'CONSULTAS',
        name: 'CONSULTAS',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 4,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'DEFUNCIONES',
        name: 'DEFUNCIONES',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 5,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'DICOM',
        name: 'DICOM',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 6,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'DIRECCIONES',
        name: 'DIRECCIONES',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 7,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'DIRECTORIO_EMPRESAS',
        name: 'DIRECTORIO EMPRESAS',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 8,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'DIRECTORIO_PERSONAS',
        name: 'DIRECTORIO PERSONAS',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 9,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'QUIEBRAS',
        name: 'QUIEBRAS',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      {
        id: 10,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'SOCIOS',
        name: 'SOCIOS',
        secureDispatch: false,
        state: false,
        emails: [],
      },
    ],
    PY: [
      // {
      //     id: 1,
      //     alert_id: null,
      //     id_tracking_record: null,
      //     alert_type: "FAJA",
      //     name: "Faja",
      //     secureDispatch: false,
      //     state: false,
      //     emails: []
      // },
      {
        id: 2,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BASE_NEGATIVA_MORA_TEMPRANA',
        name: 'Bases Negativas PROD',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      // {
      //     id: 3,
      //     alert_id: null,
      //     id_tracking_record: null,
      //     alert_type: "MORAS_EXCHANGE",
      //     name: "Moras Exchange",
      //     secureDispatch: false,
      //     state: false,
      //     emails: []
      // },
      {
        id: 4,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BASES_POSITIVAS',
        name: 'Bases Positivas',
        secureDispatch: false,
        state: false,
        emails: [],
      },
    ],
    BR: [
      // {
      //     id: 1,
      //     alert_id: null,
      //     id_tracking_record: null,
      //     alert_type: "FAJA",
      //     name: "Faja",
      //     secureDispatch: false,
      //     state: false,
      //     emails: []
      // },
      {
        id: 2,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BASE_NEGATIVA_MORA_TEMPRANA',
        name: 'Bases Negativas PROD',
        secureDispatch: false,
        state: false,
        emails: [],
      },
      // {
      //     id: 3,
      //     alert_id: null,
      //     id_tracking_record: null,
      //     alert_type: "MORAS_EXCHANGE",
      //     name: "Moras Exchange",
      //     secureDispatch: false,
      //     state: false,
      //     emails: []
      // },
      {
        id: 4,
        alert_id: null,
        id_tracking_record: null,
        alert_type: 'BASES_POSITIVAS',
        name: 'Bases Positivas',
        secureDispatch: false,
        state: false,
        emails: [],
      },
    ],
  },
  chartPE: {
    indicatorName: [
      {
        id: 0,
        isStatic: true,
        name: 'RESUMEN',
        title: 'Resumen de indicadores',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
      },
      {
        id: 1,
        name: 'INDICADOR_1',
        nameShow: 'Score Equifax',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Score Equifax',
      },
      {
        id: 2,
        name: 'INDICADOR_2',
        nameShow: 'Calificación SBS',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Calificación SBS',
      },
      {
        id: 3,
        name: 'INDICADOR_3',
        nameShow: 'Calificación Infocorp/SICOM',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Calificación Infocorp/SICOM',
      },
      {
        id: 4,
        name: 'PROTESTOS',
        nameShow: 'Protestos',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Protestos',
      },
      {
        id: 5,
        name: 'CONSULTAS_REPORTE_CREDITO',
        nameShow: 'Consultas al reporte de crédito',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Consultas al reporte de crédito',
      },
      {
        id: 6,
        name: 'LISTAS_PEP',
        nameShow: 'Listas PEP',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Listas PEP',
      },
      {
        id: 7,
        name: 'AVAL_AVALADO_SI_NO',
        nameShow: 'Aval/Avalado (Si o no)',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Aval/Avalado (Si o no)',
      },
    ],
  },
  chartPY: {
    indicatorName: [
      {
        id: 0,
        isStatic: true,
        name: 'RESUMEN',
        title: 'Resumen de indicadores',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
      },
      {
        id: 13,
        name: 'FAJA',
        nameShow: 'FAJA',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Faja',
      },
      {
        id: 14,
        name: 'DEMANDAS JUDICIALES',
        nameShow: 'DEMANDAS_JUDICIALES',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Demandas Judiciales',
      },
      {
        id: 15,
        name: 'REMATES',
        nameShow: 'REMATES',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Remates',
      },
      {
        id: 16,
        name: 'INHIBIDORES',
        nameShow: 'INHIBICIONES',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Inhibiciones',
      },
      {
        id: 17,
        name: 'CONVOCATORIAS',
        nameShow: 'CONVOCATORIAS',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Convocatorias',
      },
      {
        id: 18,
        name: 'QUIEBRAS',
        nameShow: 'QUIEBRAS',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Quiebras',
      },
      {
        id: 19,
        name: 'MOROSIDADES PUBLICA',
        nameShow: 'MOROSIDADES_PUBLICA',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Morosidad Publica',
      },
      {
        id: 20,
        name: 'SUSPENCIONES INFORMCONF',
        nameShow: 'SUSPENCIONES_INFORMCONF',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Suspensiones INFORMCONF',
      },
      {
        id: 21,
        name: 'MORA TEMPRANA COMERCIAL',
        nameShow: 'MORA_TEMPRANA_COMERCIAL',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Mora Temprana Comercial',
      },
      {
        id: 22,
        name: 'MOROSIDAD (ADEFI)',
        nameShow: 'MOROSIDAD_ADEFI',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Morosidad (ADEFI)',
      },
      {
        id: 23,
        name: 'NUEVO PRODUCTO: PRESTAMOS',
        nameShow: 'NUEVO_PRODUCTO_PRESTAMOS',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Nuevo Producto: Prestamos',
      },
      {
        id: 24,
        name: 'NUEVO PRODUCTO: TARJETAS',
        nameShow: 'NUEVO_PRODUCTO_TARJETAS',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Nuevo Producto: Tarjetas',
      },
      {
        id: 25,
        name: 'NUEVO PRODUCTO: SERVICIOS',
        nameShow: 'NUEVO_PRODUCTO_SERVICIOS',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Nuevo Producto: Servicios',
      },
      {
        id: 26,
        name: 'MAXIMO DIAS DE ATRASO',
        nameShow: 'MAXIMO_DIAS_DE_ATRASO',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Maximo Días De Atraso',
      },
      {
        id: 27,
        name: 'SALDO TOTAL',
        nameShow: 'SALDO_TOTAL',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Saldo Total',
      },
      {
        id: 28,
        name: 'SITUACION BANCARIA',
        nameShow: 'SITUACION_BANCARIA',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Situación Bancaria',
      },
      {
        id: 30,
        name: 'SUSPENSIONES INFOCHECK',
        nameShow: 'SUSPENSIONES_INFOCHECK',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Suspenciones Infocheck',
      },
      {
        id: 31,
        name: 'SUSPENSIONES_INFOCHECK_INHABILITACIONES',
        nameShow: 'SUSPENSIONES_INFOCHECK_INHABILITACIONES',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Suspenciones Infocheck INHABILITACIONES',
      },
      {
        id: 32,
        name: 'SUSPENSIONES_INFOCHECK_REHABILITACIONES',
        nameShow: 'SUSPENSIONES_INFOCHECK_REHABILITACIONES',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Suspenciones Infocheck REHABILITACIONES',
      },
    ],
  },
  chartBR: {
    indicatorName: [
      {
        id: 0,
        isStatic: true,
        name: 'RESUMEN',
        title: 'Resumen de indicadores',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
      },
      {
        id: 13,
        name: 'FAJA',
        nameShow: 'FAJA',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Faja',
      },
      {
        id: 14,
        name: 'DEMANDAS JUDICIALES',
        nameShow: 'DEMANDAS_JUDICIALES',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Demandas Judiciales',
      },
      {
        id: 15,
        name: 'REMATES',
        nameShow: 'REMATES',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Remates',
      },
      {
        id: 16,
        name: 'INHIBIDORES',
        nameShow: 'INHIBICIONES',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Inhibiciones',
      },
      {
        id: 17,
        name: 'CONVOCATORIAS',
        nameShow: 'CONVOCATORIAS',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Convocatorias',
      },
      {
        id: 18,
        name: 'QUIEBRAS',
        nameShow: 'QUIEBRAS',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Quiebras',
      },
      {
        id: 19,
        name: 'MOROSIDADES PUBLICA',
        nameShow: 'MOROSIDADES_PUBLICA',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Morosidad Publica',
      },
      {
        id: 20,
        name: 'SUSPENCIONES INFORMCONF',
        nameShow: 'SUSPENCIONES_INFORMCONF',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Suspensiones INFORMCONF',
      },
      {
        id: 21,
        name: 'MORA TEMPRANA COMERCIAL',
        nameShow: 'MORA_TEMPRANA_COMERCIAL',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Mora Temprana Comercial',
      },
      {
        id: 22,
        name: 'MOROSIDAD (ADEFI)',
        nameShow: 'MOROSIDAD_ADEFI',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Morosidad (ADEFI)',
      },
      {
        id: 23,
        name: 'NUEVO PRODUCTO: PRESTAMOS',
        nameShow: 'NUEVO_PRODUCTO_PRESTAMOS',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Nuevo Producto: Prestamos',
      },
      {
        id: 24,
        name: 'NUEVO PRODUCTO: TARJETAS',
        nameShow: 'NUEVO_PRODUCTO_TARJETAS',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Nuevo Producto: Tarjetas',
      },
      {
        id: 25,
        name: 'NUEVO PRODUCTO: SERVICIOS',
        nameShow: 'NUEVO_PRODUCTO_SERVICIOS',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Nuevo Producto: Servicios',
      },
      {
        id: 26,
        name: 'MAXIMO DIAS DE ATRASO',
        nameShow: 'MAXIMO_DIAS_DE_ATRASO',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Maximo Días De Atraso',
      },
      {
        id: 27,
        name: 'SALDO TOTAL',
        nameShow: 'SALDO_TOTAL',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Saldo Total',
      },
      {
        id: 28,
        name: 'SITUACION BANCARIA',
        nameShow: 'SITUACION_BANCARIA',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Situación Bancaria',
      },
      {
        id: 30,
        name: 'SUSPENSIONES INFOCHECK',
        nameShow: 'SUSPENSIONES_INFOCHECK',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Suspenciones Infocheck',
      },
      {
        id: 31,
        name: 'SUSPENSIONES_INFOCHECK_INHABILITACIONES',
        nameShow: 'SUSPENSIONES_INFOCHECK_INHABILITACIONES',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Suspenciones Infocheck INHABILITACIONES',
      },
      {
        id: 32,
        name: 'SUSPENSIONES_INFOCHECK_REHABILITACIONES',
        nameShow: 'SUSPENSIONES_INFOCHECK_REHABILITACIONES',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
        isStatic: true,
        title: 'Suspenciones Infocheck REHABILITACIONES',
      },
    ],
  },
  chartCL: {
    indicatorName: [
      {
        id: 0,
        isStatic: true,
        name: 'RESUMEN',
        title: 'Resumen de indicadores',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
      },
      {
        id: 7,
        isStatic: true,
        name: 'PUNTAJE',
        title: 'Puntaje/Clasificador (riesgos)',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
      },
      {
        id: 2,
        isStatic: true,
        name: 'MOROSIDADES_E_IMPAGOS',
        title: 'Documento de morosidades y protestos',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
      },
      {
        id: 8,
        isStatic: true,
        name: 'GRANDES_TIENDAS',
        title: 'Grandes Tiendas - ICOM',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
      },
      {
        id: 3,
        isStatic: true,
        name: 'BOLETIN_LABORAL',
        title: 'Boletín Infracciones Laborales y Previsionales',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
      },
      {
        id: 4,
        isStatic: true,
        name: 'SOCIOS_Y_SOCIEDADES',
        title: 'Constitución y Modificación de Sociedades',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
      },
      {
        id: 5,
        isStatic: true,
        name: 'QUIEBRAS',
        title: 'Documento de quiebras',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
      },
      // {
      //     id: 6,
      //     isStatic: true,
      //     name: "SITUACION_TRIBUTARIO",
      //     title: "Situación tributaria",
      //     personType: "PERSON",
      //     quantityReg: 0,
      //     score: 0
      // },
      {
        id: 10,
        isStatic: true,
        name: 'DIFUNTOS',
        title: 'Difuntos',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
      },
      {
        id: 11,
        isStatic: true,
        name: 'INTERDICTOS',
        title: 'Interdictos',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
      },
      {
        id: 12,
        isStatic: true,
        name: 'BOLETIN_CONCURSAL',
        title: 'Boletín Concursal',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
      },
      {
        id: 9,
        isStatic: true,
        name: 'MONTOS_IMPAGOS',
        title: 'Montos Impagos',
        personType: 'PERSON',
        quantityReg: 0,
        score: 0,
      },
    ],
    puntaje: {
      barChartData: [
        {
          data: [],
          label: '1 - 31',
          fill: false,
          lineTension: 0,
          backgroundColor: '#ffa8b8',
          hoverBackgroundColor: '#ffa8b8',
          hoverBorderColor: '#ffa8b8',
          borderColor: '#ffa8b8',
        },
        {
          data: [],
          label: '32 - 117',
          fill: false,
          lineTension: 0,
          backgroundColor: '#ffc8c3',
          hoverBackgroundColor: '#ffc8c3',
          hoverBorderColor: '#ffc8c3',
          borderColor: '#ffc8c3',
        },
        {
          data: [],
          label: '118 - 231',
          fill: false,
          lineTension: 0,
          backgroundColor: '#f7d8c3',
          hoverBackgroundColor: '#f7d8c3',
          hoverBorderColor: '#f7d8c3',
          borderColor: '#f7d8c3',
        },
        {
          data: [],
          label: '232 - 441',
          fill: false,
          lineTension: 0,
          backgroundColor: '#fae187',
          hoverBackgroundColor: '#fae187',
          hoverBorderColor: '#fae187',
          borderColor: '#fae187',
        },
        {
          data: [],
          label: '442 - 607',
          fill: false,
          lineTension: 0,
          backgroundColor: '#c5d084',
          hoverBackgroundColor: '#c5d084',
          hoverBorderColor: '#c5d084',
          borderColor: '#c5d084',
        },
        {
          data: [],
          label: '608 - 795',
          fill: false,
          lineTension: 0,
          backgroundColor: '#a0d995',
          hoverBackgroundColor: '#a0d995',
          hoverBorderColor: '#a0d995',
          borderColor: '#a0d995',
        },
        {
          data: [],
          label: '796 - 999',
          fill: false,
          lineTension: 0,
          backgroundColor: '#a2edce',
          hoverBackgroundColor: '#a2edce',
          hoverBorderColor: '#a2edce',
          borderColor: '#a2edce',
        },
      ],
      data: {
        chartName: 'Puntaje',
        frequencySubscription: 'Semanal',
        periods: [
          {
            period: '02/07-27/06',
            values: [
              {
                range: '796 - 999',
                rut: '',
                quantity: 12,
              },
              {
                range: '608 - 795',
                rut: '',
                quantity: 4,
              },
              {
                range: '442 - 607',
                rut: '',
                quantity: 6,
              },
              {
                range: '232 - 441',
                rut: '',
                quantity: 8,
              },
              {
                range: '118 - 231',
                rut: '',
                quantity: 10,
              },
              {
                range: '32 - 117',
                rut: '',
                quantity: 12,
              },
              {
                range: '1 - 31',
                rut: '',
                quantity: 14,
              },
            ],
          },
          {
            period: '26/06-20/06',
            values: [
              {
                range: '796 - 999',
                rut: '',
                quantity: 2,
              },
              {
                range: '608 - 795',
                rut: '',
                quantity: 2,
              },
              {
                range: '442 - 607',
                rut: '',
                quantity: 2,
              },
              {
                range: '232 - 441',
                rut: '',
                quantity: 2,
              },
              {
                range: '118 - 231',
                rut: '',
                quantity: 2,
              },
              {
                range: '32 - 117',
                rut: '',
                quantity: 2,
              },
              {
                range: '1 - 31',
                rut: '',
                quantity: 2,
              },
            ],
          },
          {
            period: '19/06-13/06',
            values: [],
          },
          {
            period: '12/06-06/06',
            values: [],
          },
          {
            period: '05/06-30/05',
            values: [],
          },
          {
            period: '29/05-23/05',
            values: [],
          },
          {
            period: '22/05-16/05',
            values: [],
          },
          {
            period: '15/05-09/05',
            values: [],
          },
          {
            period: '08/05-02/05',
            values: [],
          },
          {
            period: '01/05-25/04',
            values: [],
          },
        ],
      },
    },
    quiebra: {
      barChartData: [
        {
          data: [],
          label: '999',
          fill: false,
          lineTension: 0,
          backgroundColor: '#ffa8b8',
          hoverBackgroundColor: '#ffa8b8',
          hoverBorderColor: '#ffa8b8',
          borderColor: '#ffa8b8',
        },
      ],
    },
    protestoMorosidad: {
      data: {
        chartName: 'Puntaje',
        frequencySubscription: 'Semanal',
        periods: [
          {
            period: '02/07',
            values: [],
          },
          {
            period: '26/06',
            values: [
              {
                range: '796 - 999',
                rut: '',
                quantity: 2,
              },
              {
                range: '608 - 795',
                rut: '',
                quantity: 2,
              },
              {
                range: '442 - 607',
                rut: '',
                quantity: 2,
              },
              {
                range: '232 - 441',
                rut: '',
                quantity: 2,
              },
              {
                range: '118 - 231',
                rut: '',
                quantity: 2,
              },
              {
                range: '32 - 117',
                rut: '',
                quantity: 2,
              },
              {
                range: '1 - 31',
                rut: '',
                quantity: 2,
              },
            ],
          },
          {
            period: '19/06',
            values: [
              {
                range: '796 - 999',
                rut: '',
                quantity: 12,
              },
              {
                range: '608 - 795',
                rut: '',
                quantity: 4,
              },
              {
                range: '442 - 607',
                rut: '',
                quantity: 6,
              },
              {
                range: '232 - 441',
                rut: '',
                quantity: 8,
              },
              {
                range: '118 - 231',
                rut: '',
                quantity: 10,
              },
              {
                range: '32 - 117',
                rut: '',
                quantity: 12,
              },
              {
                range: '1 - 31',
                rut: '',
                quantity: 14,
              },
            ],
          },
          {
            period: '12/06',
            values: [],
          },
          {
            period: '05/06',
            values: [],
          },
          {
            period: '29/05',
            values: [],
          },
          {
            period: '22/05',
            values: [],
          },
          {
            period: '15/05',
            values: [],
          },
          {
            period: '08/05',
            values: [],
          },
          {
            period: '01/05',
            values: [],
          },
          {
            period: '01/05',
            values: [],
          },
          {
            period: '01/05',
            values: [],
          },
        ],
      },
    },
    boletinLaboral: {
      data: {
        chartName: 'Puntaje',
        frequencySubscription: 'Semanal',
        periods: [
          {
            period: '02/07/2022',
            values: [],
          },
          {
            period: '26/06/2022',
            values: [],
          },
          {
            period: '19/06/2022',
            values: [],
          },
          {
            period: '12/06/2022',
            values: [
              {
                range: '796 - 999',
                rut: '',
                quantity: 2,
              },
              {
                range: '608 - 795',
                rut: '',
                quantity: 2,
              },
              {
                range: '442 - 607',
                rut: '',
                quantity: 2,
              },
              {
                range: '232 - 441',
                rut: '',
                quantity: 2,
              },
              {
                range: '118 - 231',
                rut: '',
                quantity: 2,
              },
              {
                range: '32 - 117',
                rut: '',
                quantity: 2,
              },
              {
                range: '1 - 31',
                rut: '',
                quantity: 2,
              },
            ],
          },
          {
            period: '05/06/2022',
            values: [],
          },
          {
            period: '29/05/2022',
            values: [],
          },
          {
            period: '22/05/2022',
            values: [],
          },
          {
            period: '15/05/2022',
            values: [],
          },
          {
            period: '08/05/2022',
            values: [],
          },
          {
            period: '01/05/2022',
            values: [],
          },
          {
            period: '24/04/2022',
            values: [],
          },
          {
            period: '17/04/2022',
            values: [
              {
                range: '796 - 999',
                rut: '',
                quantity: 12,
              },
              {
                range: '608 - 795',
                rut: '',
                quantity: 4,
              },
              {
                range: '442 - 607',
                rut: '',
                quantity: 6,
              },
              {
                range: '232 - 441',
                rut: '',
                quantity: 8,
              },
              {
                range: '118 - 231',
                rut: '',
                quantity: 10,
              },
              {
                range: '32 - 117',
                rut: '',
                quantity: 12,
              },
              {
                range: '1 - 31',
                rut: '',
                quantity: 14,
              },
            ],
          },
        ],
      },
    },
    sociosSociedades: {
      data: {
        chartName: 'Puntaje',
        frequencySubscription: 'Semanal',
        periods: [
          {
            period: '02/07',
            values: [],
          },
          {
            period: '26/06',
            values: [],
          },
          {
            period: '19/06',
            values: [],
          },
          {
            period: '12/06',
            values: [],
          },
          {
            period: '05/06',
            values: [
              {
                range: '796 - 999',
                rut: '',
                quantity: 2,
              },
              {
                range: '608 - 795',
                rut: '',
                quantity: 2,
              },
              {
                range: '442 - 607',
                rut: '',
                quantity: 2,
              },
              {
                range: '232 - 441',
                rut: '',
                quantity: 2,
              },
              {
                range: '118 - 231',
                rut: '',
                quantity: 2,
              },
              {
                range: '32 - 117',
                rut: '',
                quantity: 2,
              },
              {
                range: '1 - 31',
                rut: '',
                quantity: 2,
              },
            ],
          },
          {
            period: '29/05',
            values: [],
          },
          {
            period: '22/05',
            values: [],
          },
          {
            period: '15/05',
            values: [],
          },
          {
            period: '08/05',
            values: [
              {
                range: '796 - 999',
                rut: '',
                quantity: 12,
              },
              {
                range: '608 - 795',
                rut: '',
                quantity: 4,
              },
              {
                range: '442 - 607',
                rut: '',
                quantity: 6,
              },
              {
                range: '232 - 441',
                rut: '',
                quantity: 8,
              },
              {
                range: '118 - 231',
                rut: '',
                quantity: 10,
              },
              {
                range: '32 - 117',
                rut: '',
                quantity: 12,
              },
              {
                range: '1 - 31',
                rut: '',
                quantity: 14,
              },
            ],
          },
          {
            period: '01/05',
            values: [],
          },
          {
            period: '24/04',
            values: [],
          },
          {
            period: '17/04',
            values: [
              {
                range: '796 - 999',
                rut: '',
                quantity: 12,
              },
              {
                range: '608 - 795',
                rut: '',
                quantity: 4,
              },
              {
                range: '442 - 607',
                rut: '',
                quantity: 6,
              },
              {
                range: '232 - 441',
                rut: '',
                quantity: 8,
              },
              {
                range: '118 - 231',
                rut: '',
                quantity: 10,
              },
              {
                range: '32 - 117',
                rut: '',
                quantity: 12,
              },
              {
                range: '1 - 31',
                rut: '',
                quantity: 14,
              },
            ],
          },
        ],
      },
    },
    quiebras: {
      data: {
        chartName: 'Quiebra',
        frequencySubscription: 'Semanal',
        periods: [
          {
            period: '27/06-02/07',
            values: [],
          },
          {
            period: '20/06-26/06',
            values: [],
          },
          {
            period: '13/06-19/06',
            values: [
              {
                range: '999',
                rut: '',
                quantity: 120,
              },
            ],
          },
          {
            period: '06/06-12/06',
            values: [],
          },
          {
            period: '30/05-05/06',
            values: [
              {
                range: '999',
                rut: '',
                quantity: 200,
              },
            ],
          },
          {
            period: '23/05-29/05',
            values: [],
          },
          {
            period: '16/05-22/05',
            values: [],
          },
          {
            period: '09/05-15/05',
            values: [],
          },
          {
            period: '02/05-08/05',
            values: [],
          },
          {
            period: '25/04-01/05',
            values: [],
          },
          {
            period: '18/04-24/04',
            values: [],
          },
          {
            period: '10/04-17/04',
            values: [
              {
                range: '999',
                rut: '',
                quantity: 120,
              },
            ],
          },
        ],
      },
    },
    situacionTributario: {
      data: {
        chartName: 'Puntaje',
        frequencySubscription: 'Semanal',
        periods: [
          {
            period: '02/07',
            values: [
              {
                range: '796 - 999',
                rut: '',
                quantity: 12,
              },
              {
                range: '608 - 795',
                rut: '',
                quantity: 4,
              },
              {
                range: '442 - 607',
                rut: '',
                quantity: 6,
              },
              {
                range: '232 - 441',
                rut: '',
                quantity: 8,
              },
              {
                range: '118 - 231',
                rut: '',
                quantity: 10,
              },
              {
                range: '32 - 117',
                rut: '',
                quantity: 12,
              },
              {
                range: '1 - 31',
                rut: '',
                quantity: 14,
              },
            ],
          },
          {
            period: '26/06',
            values: [
              {
                range: '796 - 999',
                rut: '',
                quantity: 12,
              },
              {
                range: '608 - 795',
                rut: '',
                quantity: 4,
              },
              {
                range: '442 - 607',
                rut: '',
                quantity: 6,
              },
              {
                range: '232 - 441',
                rut: '',
                quantity: 8,
              },
              {
                range: '118 - 231',
                rut: '',
                quantity: 10,
              },
              {
                range: '32 - 117',
                rut: '',
                quantity: 12,
              },
              {
                range: '1 - 31',
                rut: '',
                quantity: 14,
              },
            ],
          },
          {
            period: '19/06',
            values: [
              {
                range: '796 - 999',
                rut: '',
                quantity: 12,
              },
              {
                range: '608 - 795',
                rut: '',
                quantity: 4,
              },
              {
                range: '442 - 607',
                rut: '',
                quantity: 6,
              },
              {
                range: '232 - 441',
                rut: '',
                quantity: 8,
              },
              {
                range: '118 - 231',
                rut: '',
                quantity: 10,
              },
              {
                range: '32 - 117',
                rut: '',
                quantity: 12,
              },
              {
                range: '1 - 31',
                rut: '',
                quantity: 14,
              },
            ],
          },
          {
            period: '12/06',
            values: [],
          },
          {
            period: '05/06',
            values: [
              {
                range: '796 - 999',
                rut: '',
                quantity: 2,
              },
              {
                range: '608 - 795',
                rut: '',
                quantity: 2,
              },
              {
                range: '442 - 607',
                rut: '',
                quantity: 2,
              },
              {
                range: '232 - 441',
                rut: '',
                quantity: 2,
              },
              {
                range: '118 - 231',
                rut: '',
                quantity: 2,
              },
              {
                range: '32 - 117',
                rut: '',
                quantity: 2,
              },
              {
                range: '1 - 31',
                rut: '',
                quantity: 2,
              },
            ],
          },
          {
            period: '29/05',
            values: [],
          },
          {
            period: '22/05',
            values: [],
          },
          {
            period: '15/05',
            values: [],
          },
          {
            period: '08/05',
            values: [],
          },
          {
            period: '01/05',
            values: [],
          },
          {
            period: '24/04',
            values: [],
          },
          {
            period: '17/04',
            values: [
              {
                range: '796 - 999',
                rut: '',
                quantity: 12,
              },
              {
                range: '608 - 795',
                rut: '',
                quantity: 4,
              },
              {
                range: '442 - 607',
                rut: '',
                quantity: 6,
              },
              {
                range: '232 - 441',
                rut: '',
                quantity: 8,
              },
              {
                range: '118 - 231',
                rut: '',
                quantity: 10,
              },
              {
                range: '32 - 117',
                rut: '',
                quantity: 12,
              },
              {
                range: '1 - 31',
                rut: '',
                quantity: 14,
              },
            ],
          },
        ],
      },
    },
    barChartOne: [
      {
        data: [],
        label: '',
        fill: false,
        lineTension: 0,
        backgroundColor: '#ffa8b8',
        hoverBackgroundColor: '#ffa8b8',
        hoverBorderColor: '#ffa8b8',
        borderColor: '#ffa8b8',
      },
    ],
    barChartDataCR: [
      {
        data: [],
        fill: false,
        lineTension: 0,
        label: 'Variación',
        backgroundColor: '#a9e5e3',
        hoverBackgroundColor: '#a2edce',
        hoverBorderColor: '#a9e5e3',
        borderColor: '#a9e5e3',
      },
    ],
    barChartData: [
      {
        data: [],
        fill: false,
        lineTension: 0,
        label: 'Sin Variación',
        backgroundColor: '#a9e5e3',
        hoverBackgroundColor: '#a2edce',
        hoverBorderColor: '#a9e5e3',
        borderColor: '#a9e5e3',
      },
      {
        data: [],
        fill: false,
        lineTension: 0,
        label: 'Positiva',
        backgroundColor: '#a0d995',
        hoverBackgroundColor: '#c5d084',
        hoverBorderColor: '#a0d995',
        borderColor: '#a0d995',
      },
      {
        data: [],
        fill: false,
        lineTension: 0,
        label: 'Negativa',
        backgroundColor: '#ffa8b8',
        hoverBackgroundColor: '#ffc8c3',
        hoverBorderColor: '#ffa8b8',
        borderColor: '#ffa8b8',
      },
    ],
    barChartLegend: {
      display: false,
      position: 'bottom',
      align: 'start',
    },
    barChartOptions: {
      scaleShowVerticalLines: false,
      responsive: true,
      scales: {
        xAxes: [
          {
            stacked: true,
            ticks: {
              stepSize: 1,
            },
          },
        ],
        yAxes: [
          {
            stacked: true,
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
      legend: {
        display: true,
        position: 'bottom',
      },
    },
    barChartTypeH: 'horizontalBar',
    barChartTypeV: 'bar',
    lineChartData: [
      {
        data: [],
        fill: false,
        lineTension: 0,
        label: 'Score',
      },
    ],
    lineChartDataMontosImpagos: [
      {
        data: [],
        fill: false,
        lineTension: 0,
        label: '',
      },
    ],
    lineChartLegend: {
      display: false,
      position: 'bottom',
      align: 'start',
    },
    lineChartOptions: {
      responsive: true,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
    },
    lineChartType: 'line',
    lineChartLabels: ['January', 'February', 'March', 'April', 'May', 'June'],
  },
  tableHeadCartera: [
    'Ruts',
    'Nombre',
    'Ejecutivo',
    'Sucursal',
    'Tipo de Cliente',
    'Puntaje/Clasificador (riesgos)',
    'Documento de morosidades y protestos',
    'Grandes Tiendas - ICOM',
    'Boletín Infracciones Laborales y Previsionales',
    'Constitución y Modificación de Sociedades',
    'Documento de quiebras',
    'Situación tributaria',
    'Montos Impagos',
    'Interdictos',
    'Boletín Concursal',
    'Difuntos',
  ],
  test: {
    tableTitle: {
      resumen: [
        'Puntaje/Clasificador (riesgos)',
        'Documento de morosidades y protestos',
        'Grandes Tiendas - ICOM',
        'Boletín Infracciones Laborales y Previsionales',
        'Constitución y Modificación de Sociedades',
        'Documento de quiebras',
        'Situación tributaria',
        'Montos Impagos',
        'Interdictos',
        'Boletín Concursal',
        'Difuntos',
      ],
    },
    tableData: {
      resumen: [0, 2, 1, 5, -6, 7, 3, 0, 'Si', 'No', 'Si'],
    },
    dashboardCl: {
      data: {
        chartName: 'RESUMEN INDICADORES',
        rangePeriod: '18/09/2023 al 24/09/2023',
        frequencySubscription: 'Semanal',
        amountHash: 10,
        indicatorsData: [
          {
            name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
            quantity: 2,
            variation: 4,
          },
          {
            name: 'INTERDICTOS',
            quantity: 4,
            variation: 2,
          },
          {
            name: 'CONSTITUCION Y MODIFICACIONES DE SOCIEDADES',
            quantity: 6,
            variation: 4,
          },
          {
            name: 'BOLETIN CONSURSAL',
            quantity: 6,
            variation: 8,
          },
          {
            name: 'REGISTRO DE QUIEBRAS',
            quantity: 2,
            variation: 3,
          },
          {
            name: 'REGISTRO DE MOROSIDADES Y PROTESTOS',
            quantity: 1,
            variation: 5,
          },
          {
            name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
            quantity: 4,
            variation: 9,
          },
          {
            name: 'GRANDES TIENDAS - ICOM',
            quantity: 5,
            variation: 0,
          },
          {
            name: 'CROSS',
            quantity: 8,
            variation: -2,
          },
          {
            name: 'DIFUNTOS',
            quantity: 3,
            variation: 4,
          },
          {
            name: 'SITUACION TRIBUTARIA',
            quantity: 7,
            variation: -3,
          },
          {
            name: 'MONTOS IMPAGOS',
            quantity: 6,
            variation: -4,
          },
        ],
      },
    },
    alertCloud: {
      efxId: '198188366',
      targetEmail: 'jeremy3@equifax.com,jeremy@equifax.com,haas@sad.co',
      configurations: [
        {
          id_tracking_record: 472,
          alert_type: 'DICOM',
          state: true,
          emails: ['jeremy3@equifax.com', 'jeremy@equifax.com', 'haas@sad.co'],
        },
        {
          id_tracking_record: 62980,
          alert_type: 'SOCIOS',
          state: true,
          emails: ['jeremy3@equifax.com', 'jeremy@equifax.com', 'haas@sad.co'],
        },
        {
          id_tracking_record: 475,
          alert_type: 'BOLCOM',
          state: true,
          emails: ['jeremy3@equifax.com', 'jeremy@equifax.com', 'haas@sad.co'],
        },
        {
          id_tracking_record: 480,
          alert_type: 'QUIEBRAS',
          state: true,
          emails: ['jeremy3@equifax.com', 'jeremy@equifax.com', 'haas@sad.co'],
        },
        {
          id_tracking_record: 473,
          alert_type: 'BIENES_RAICES',
          state: true,
          emails: ['jeremy3@equifax.com', 'jeremy@equifax.com', 'haas@sad.co'],
        },
        {
          id_tracking_record: 479,
          alert_type: 'PRENDAS',
          state: true,
          emails: ['jeremy3@equifax.com', 'jeremy@equifax.com', 'haas@sad.co'],
        },
        {
          id_tracking_record: 477,
          alert_type: 'DIRECTORIO_EMPRESAS',
          state: true,
          emails: ['jeremy3@equifax.com', 'jeremy@equifax.com', 'haas@sad.co'],
        },
        {
          id_tracking_record: 474,
          alert_type: 'DEFUNCIONES',
          state: true,
          emails: ['jeremy3@equifax.com', 'jeremy@equifax.com', 'haas@sad.co'],
        },
        {
          id_tracking_record: 478,
          alert_type: 'DIRECTORIO_PERSONAS',
          state: true,
          emails: ['jeremy3@equifax.com', 'jeremy@equifax.com', 'haas@sad.co'],
        },
        {
          id_tracking_record: 470,
          alert_type: 'CONSULTAS',
          state: false,
          emails: ['jeremy3@equifax.com', 'jeremy@equifax.com', 'haas@sad.co'],
        },
        {
          id_tracking_record: 476,
          alert_type: 'DIRECCIONES',
          state: true,
          emails: ['jeremy3@equifax.com', 'jeremy@equifax.com', 'haas@sad.co'],
        },
      ],
    },
    carteras: {
      PERSON: {
        pageNumber: 0,
        pageSize: 50,
        pageTotal: 27,
        list: [
          {
            id: 3257,
            name: 'TODOS LOS INDIVIDUOS',
            entityType: null,
            personType: 'PERSON',
            isFull: false,
            favorite: false,
            score: null,
            quantityReg: 1001,
            isStatic: true,
            dinamicQuery: null,
            base: true,
            scoreSummary: [
              {
                period: 1690858800000,
                periodString: '2023-08',
                indicatorName: 'score',
                rangeValues: {
                  '0-199': 3,
                  '200-399': 1,
                  '400-599': 5,
                  '600-799': 1,
                  '800-999': 7,
                },
                behaviours: {
                  eq: [126664],
                  created: [
                    126667, 126684, 126685, 126686, 126687, 126695, 126697, 126698, 126699, 126700,
                    126701, 126702, 126703, 126705, 126709,
                  ],
                  asc: [126704],
                },
                totalRegisters: 17,
                averageValue: 597.6470588235294,
                alertsQuantity: 0,
              },
            ],
            ipSummary: null,
            deudaTotalSgSummary: null,
            deudaTotalCgSummary: null,
            morosidadSummary: null,
            antiguedadSummary: null,
            saldoVencidoSummary: null,
            behavior: null,
            averageScore: null,
          },
          {
            id: 4903,
            name: '11',
            entityType: null,
            personType: 'PERSON',
            isFull: false,
            favorite: false,
            score: null,
            quantityReg: 4,
            isStatic: false,
            dinamicQuery: null,
            base: false,
            scoreSummary: [
              {
                period: 1690858800000,
                periodString: '2023-08',
                indicatorName: 'score',
                rangeValues: {
                  '0-199': 0,
                  '200-399': 0,
                  '400-599': 0,
                  '600-799': 0,
                  '800-999': 4,
                },
                behaviours: {
                  eq: [126664],
                  created: [126705, 126709],
                  asc: [126704],
                },
                totalRegisters: 4,
                averageValue: 990.0,
                alertsQuantity: 0,
              },
            ],
            ipSummary: null,
            deudaTotalSgSummary: null,
            deudaTotalCgSummary: null,
            morosidadSummary: null,
            antiguedadSummary: null,
            saldoVencidoSummary: null,
            behavior: null,
            averageScore: null,
          },
          {
            id: 4933,
            name: 'cartera dinamica m 900',
            entityType: null,
            personType: 'PERSON',
            isFull: false,
            favorite: false,
            score: null,
            quantityReg: 4,
            isStatic: false,
            dinamicQuery: null,
            base: false,
            scoreSummary: [
              {
                period: 1690858800000,
                periodString: '2023-08',
                indicatorName: 'score',
                rangeValues: {
                  '0-199': 0,
                  '200-399': 0,
                  '400-599': 0,
                  '600-799': 0,
                  '800-999': 0,
                },
                behaviours: {},
                totalRegisters: 0,
                averageValue: 0.0,
                alertsQuantity: 0,
              },
            ],
            ipSummary: null,
            deudaTotalSgSummary: null,
            deudaTotalCgSummary: null,
            morosidadSummary: null,
            antiguedadSummary: null,
            saldoVencidoSummary: null,
            behavior: null,
            averageScore: null,
          },
        ],
      },
      company: {
        pageNumber: 0,
        pageSize: 50,
        pageTotal: 1,
        list: [
          {
            id: 3256,
            name: 'Información acumulada - total carteras',
            entityType: null,
            personType: 'COMPANY',
            isFull: false,
            favorite: false,
            score: null,
            quantityReg: 5,
            isStatic: true,
            dinamicQuery: null,
            base: true,
            scoreSummary: [
              {
                period: 1690858800000,
                periodString: '2023-08',
                indicatorName: 'score',
                rangeValues: {
                  '0-199': 0,
                  '200-399': 0,
                  '400-599': 0,
                  '600-799': 0,
                  '800-999': 0,
                },
                behaviours: {},
                totalRegisters: 0,
                averageValue: 0.0,
                alertsQuantity: 0,
              },
            ],
            ipSummary: 1,
            deudaTotalSgSummary: 1,
            deudaTotalCgSummary: 1,
            morosidadSummary: 1,
            antiguedadSummary: 1,
            saldoVencidoSummary: 1,
            behavior: 1,
            averageScore: 1,
          },
          {
            id: 3256,
            name: 'RUT relacionados',
            entityType: null,
            personType: 'COMPANY',
            isFull: false,
            favorite: false,
            score: null,
            quantityReg: 5,
            isStatic: true,
            dinamicQuery: null,
            base: true,
            scoreSummary: [
              {
                period: 1690858800000,
                periodString: '2023-08',
                indicatorName: 'score',
                rangeValues: {
                  '0-199': 0,
                  '200-399': 0,
                  '400-599': 0,
                  '600-799': 0,
                  '800-999': 0,
                },
                behaviours: {},
                totalRegisters: 0,
                averageValue: 0.0,
                alertsQuantity: 0,
              },
            ],
            ipSummary: 1,
            deudaTotalSgSummary: 1,
            deudaTotalCgSummary: 1,
            morosidadSummary: 1,
            antiguedadSummary: 1,
            saldoVencidoSummary: 1,
            behavior: 1,
            averageScore: 1,
          },
          {
            id: 3256,
            name: 'Socios y sociedades',
            entityType: null,
            personType: 'COMPANY',
            isFull: false,
            favorite: false,
            score: null,
            quantityReg: 5,
            isStatic: true,
            dinamicQuery: null,
            base: true,
            scoreSummary: [
              {
                period: 1690858800000,
                periodString: '2023-08',
                indicatorName: 'score',
                rangeValues: {
                  '0-199': 0,
                  '200-399': 0,
                  '400-599': 0,
                  '600-799': 0,
                  '800-999': 0,
                },
                behaviours: {},
                totalRegisters: 0,
                averageValue: 0.0,
                alertsQuantity: 0,
              },
            ],
            ipSummary: 1,
            deudaTotalSgSummary: 1,
            deudaTotalCgSummary: 1,
            morosidadSummary: 1,
            antiguedadSummary: 1,
            saldoVencidoSummary: 1,
            behavior: 1,
            averageScore: 1,
          },
        ],
      },
    },
    all: {
      country: 'CHILE',
      periods: [
        {
          init: '2023-09-11',
          persons: [
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20220809',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '021794015K',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201006',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '610',
                      fecha_de_resolucion: '20221230',
                      pagina_diario: '2002',
                      tribunal: '2 JUZ DE LETRAS DE SANTIAGO',
                      rol: '13633-12',
                    },
                    {
                      extraccion_diario: '610',
                      fecha_de_resolucion: '20221230',
                      pagina_diario: '2002',
                      tribunal: '2 JUZ DE LETRAS DE SANTIAGO',
                      rol: '13633-12',
                    },
                  ],
                },
              ],
              hash: '1000000015',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'SAN MIGUEL',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'SAN MIGUEL',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20220809',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '610',
                      fecha_de_resolucion: '20221230',
                      pagina_diario: '2002',
                      tribunal: '2 JUZ DE LETRAS DE SANTIAGO',
                      rol: '13633-12',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1000100001',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201006',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1010000005',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201005',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1100000012',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201020',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1100000101',
            },
          ],
          week: 38,
          year: 2023,
          end: '2023-09-17',
        },
        {
          init: '2023-09-04',
          persons: [
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20220809',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '021794015K',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201006',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '610',
                      fecha_de_resolucion: '20221230',
                      pagina_diario: '2002',
                      tribunal: '2 JUZ DE LETRAS DE SANTIAGO',
                      rol: '13633-12',
                    },
                    {
                      extraccion_diario: '610',
                      fecha_de_resolucion: '20221230',
                      pagina_diario: '2002',
                      tribunal: '2 JUZ DE LETRAS DE SANTIAGO',
                      rol: '13633-12',
                    },
                  ],
                },
              ],
              hash: '1000000015',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'SAN MIGUEL',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'SAN MIGUEL',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20220809',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '610',
                      fecha_de_resolucion: '20221230',
                      pagina_diario: '2002',
                      tribunal: '2 JUZ DE LETRAS DE SANTIAGO',
                      rol: '13633-12',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1000100001',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201006',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1010000005',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201005',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1100000012',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201020',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1100000101',
            },
          ],
          week: 37,
          year: 2023,
          end: '2023-09-10',
        },
        {
          init: '2023-08-28',
          persons: [
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20220809',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '021794015K',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201006',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '610',
                      fecha_de_resolucion: '20221230',
                      pagina_diario: '2002',
                      tribunal: '2 JUZ DE LETRAS DE SANTIAGO',
                      rol: '13633-12',
                    },
                    {
                      extraccion_diario: '610',
                      fecha_de_resolucion: '20221230',
                      pagina_diario: '2002',
                      tribunal: '2 JUZ DE LETRAS DE SANTIAGO',
                      rol: '13633-12',
                    },
                  ],
                },
              ],
              hash: '1000000015',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'SAN MIGUEL',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'SAN MIGUEL',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20220809',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '610',
                      fecha_de_resolucion: '20221230',
                      pagina_diario: '2002',
                      tribunal: '2 JUZ DE LETRAS DE SANTIAGO',
                      rol: '13633-12',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1000100001',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201006',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1010000005',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201005',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1100000012',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201020',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1100000101',
            },
          ],
          week: 36,
          year: 2023,
          end: '2023-09-03',
        },
        {
          init: '2023-08-21',
          persons: [],
          week: 35,
          year: 2023,
          end: '2023-08-27',
        },
        {
          init: '2023-08-14',
          persons: [],
          week: 34,
          year: 2023,
          end: '2023-08-20',
        },
        {
          init: '2023-08-07',
          persons: [],
          week: 33,
          year: 2023,
          end: '2023-08-13',
        },
        {
          init: '2023-07-31',
          persons: [],
          week: 32,
          year: 2023,
          end: '2023-08-06',
        },
        {
          init: '2023-07-24',
          persons: [
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201006',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '610',
                      fecha_de_resolucion: '20221230',
                      pagina_diario: '2002',
                      tribunal: '2 JUZ DE LETRAS DE SANTIAGO',
                      rol: '13633-12',
                    },
                    {
                      extraccion_diario: '610',
                      fecha_de_resolucion: '20221230',
                      pagina_diario: '2002',
                      tribunal: '2 JUZ DE LETRAS DE SANTIAGO',
                      rol: '13633-12',
                    },
                  ],
                },
              ],
              hash: '1000000015',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'SAN MIGUEL',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'SAN MIGUEL',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20220809',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '610',
                      fecha_de_resolucion: '20221230',
                      pagina_diario: '2002',
                      tribunal: '2 JUZ DE LETRAS DE SANTIAGO',
                      rol: '13633-12',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1000100001',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201006',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1010000005',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201005',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1100000012',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201020',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1100000101',
            },
          ],
          week: 31,
          year: 2023,
          end: '2023-07-30',
        },
        {
          init: '2023-07-17',
          persons: [
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201006',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '610',
                      fecha_de_resolucion: '20221230',
                      pagina_diario: '2002',
                      tribunal: '2 JUZ DE LETRAS DE SANTIAGO',
                      rol: '13633-12',
                    },
                    {
                      extraccion_diario: '610',
                      fecha_de_resolucion: '20221230',
                      pagina_diario: '2002',
                      tribunal: '2 JUZ DE LETRAS DE SANTIAGO',
                      rol: '13633-12',
                    },
                  ],
                },
              ],
              hash: '1000000015',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'SAN MIGUEL',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'SAN MIGUEL',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20220809',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '610',
                      fecha_de_resolucion: '20221230',
                      pagina_diario: '2002',
                      tribunal: '2 JUZ DE LETRAS DE SANTIAGO',
                      rol: '13633-12',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1000100001',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201006',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1010000005',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201005',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1100000012',
            },
            {
              indicators: [
                {
                  name: 'BOLETIN INFRACCIONES LABORALES Y PREVISIONALES',
                  detail: [
                    {
                      nro_de_boletin: '200',
                      motivo: '1',
                      tipo_de_infraccion: 'I',
                      pagina_boletin: '184926',
                      fecha_de_publicacion: '20220211',
                      institucion: 'FONASA',
                      region: '0',
                      monto_de_la_deuda: '196146.0',
                    },
                  ],
                },
                {
                  name: 'GRANDES TIENDAS - ICOM',
                  detail: [
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230829',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                    {
                      nro_documento: '0',
                      fecha_de_vencimiento: '20230830',
                      tipo_de_deuda: 'D',
                      monto: '667.14',
                      tipo_de_documento: 'TC',
                      fecha_de_publicacion: '20230829',
                      localidad: 'TACHIRA',
                      librador: '5196',
                    },
                  ],
                },
                {
                  name: 'INTERDICTOS',
                  detail: [
                    {
                      fecha_de_interdicto: '20201020',
                    },
                  ],
                },
                {
                  name: 'PUNTAJE/CLASIFICADOR (RIESGOS)',
                  detail: [
                    {
                      puntaje: '542',
                    },
                  ],
                },
                {
                  name: 'REGISTRO DE QUIEBRAS',
                  detail: [
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20220101',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                    {
                      extraccion_diario: '286',
                      fecha_de_resolucion: '20230829',
                      pagina_diario: '2150',
                      tribunal: '07 LOS CIVIL DE SANTIAGO',
                      rol: '13633-09',
                    },
                  ],
                },
              ],
              hash: '1100000101',
            },
          ],
          week: 30,
          year: 2023,
          end: '2023-07-23',
        },
      ],
    },
  },
};
